<template>
  <div class="content-section">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="sass" scoped>
  @import '~@/stylesheets/base/variables'
  @import '~@/stylesheets/helpers/transitions'
  @import '~@/stylesheets/helpers/mixins'

  .content-section
    font-family: $font-main
    font-size: clamp(12px, 2vw, $font-size-tiny)
    padding: $pad
    text-align: center
    max-width: 640px

    @media (max-width: 600px)
    padding: $pad / 2
</style>
